import React from "react";
import { G, FONT_FAMILY, OVERVIEW } from "../../constants/theme";

// One horizontal grid + one vertical rhythm for every Overview section.
//
// A section is always a full-bleed colour band (page / white / dark) whose
// INNER content is constrained to OVERVIEW.contentMax and inset by
// OVERVIEW.gutter — so the left and right content edges line up with the top
// navigation and with every other section, whether the section is a contained
// card or a deliberate two-column layout.
//
// Props
//   background   "page" | "white" | "dark"     full-bleed band colour
//   flush        skip the vertical band padding (section manages its own,
//                e.g. the card-overlap band directly under the hero)
//   divider      1px top rule (separates adjacent same-colour bands)
//   innerStyle   extra style for the constrained inner container

const BG = {
  page: "#F8FAFC",
  white: "#FFFFFF",
  dark: G.dark,
};

export default function OverviewSection({
  background = "page",
  flush = false,
  divider = false,
  style = {},
  innerStyle = {},
  children,
}) {
  return (
    <section
      style={{
        width: "100%",
        boxSizing: "border-box",
        background: BG[background] || BG.page,
        borderTop: divider ? `1px solid ${G.border}` : "none",
        padding: flush ? 0 : `${OVERVIEW.sectionPadY}px 0`,
        fontFamily: FONT_FAMILY,
        ...style,
      }}
    >
      <div
        style={{
          maxWidth: OVERVIEW.contentMax,
          margin: "0 auto",
          padding: `0 ${OVERVIEW.gutter}px`,
          boxSizing: "border-box",
          ...innerStyle,
        }}
      >
        {children}
      </div>
    </section>
  );
}
